<div
  *ngIf="pagination && pagination.count > 0 && pagesToShow.length > 1"
  class="wrapper"
  [ngClass]="{ disabled }"
>
  <div class="container">
    <div *ngIf="disabled" class="disabled-lightbox"></div>
    <a
      *ngIf="currentPage > 1"
      [routerLink]="currentPage - 1 | pageUrl"
      class="item previous-page"
    >
      <app-shared-icon name="caret-left" class="icon"></app-shared-icon>
      <app-shared-icon
        name="caret-left-white"
        class="icon-white"
      ></app-shared-icon>
    </a>

    <div class="item dots" *ngIf="showPreviousDots">...</div>

    <a
      *ngFor="let item of pagesToShow"
      [routerLink]="item | pageUrl"
      [ngClass]="{ active: item === currentPage }"
      class="item page"
      >{{ item }}</a
    >

    <div class="item dots" *ngIf="showNextDots">...</div>

    <a
      *ngIf="currentPage < pages.length"
      [routerLink]="currentPage + 1 | pageUrl"
      class="item next-page"
    >
      <app-shared-icon name="caret-right" class="icon"></app-shared-icon>
      <app-shared-icon
        name="caret-right-white"
        class="icon-white"
      ></app-shared-icon>
    </a>
  </div>
</div>
